<template>
  <span class="boss-main-container">
    <!-- ▼面接情報作成更新-->
    <interview-information-form
      v-show="!isSubmittable"
      :is-edit="isEdit"
      :job-interview.sync="jobInterview"
      :published-jobs="nonOriginalEntryFormPublishedJobs"
      @filledOut="setSubmittableAndScrollToTop(true)"
    />
    <!-- ▲面接情報作成更新-->
    <!-- ▼面接情報確認-->
    <interview-information-confirm
      v-show="isSubmittable"
      data-test="interview-information-confirm"
      :is-edit="isEdit"
      :job-interview="jobInterview"
      :published-jobs="nonOriginalEntryFormPublishedJobs"
      @back="setSubmittableAndScrollToTop(false)"
      @submitted="registerOrUpdate"
    />
  <!-- ▲面接情報確認-->
  </span>
</template>

<script>
import InterviewInformationForm from '@/components/organisms/InterviewInformationForm'
import InterviewInformationConfirm from '@/components/organisms/InterviewInformationConfirm'
import Indicator from '@/lib/indicator'
import _ from 'lodash'

export default {
  components: {
    InterviewInformationForm,
    InterviewInformationConfirm
  },
  data () {
    return {
      isSubmittable: false,
      publishedJobs: [],
      jobInterview: {
        name: '',
        jobs: [],
        paperScreening: { id: 0, name: '' },
        paperScreeningRemarks: null,
        spiTest: { id: 0, name: '' },
        spiTestRemarks: null,
        message: '',
        content: '',
        interviewers: [],
        requiredTime: { id: 0, name: '' },
        requiredTimeRemarks: null,
        cloth: { id: 0, name: '' },
        clothRemarks: null,
        businessManner: 0,
        communicationAbility: 0,
        skill: 0,
        motivation: 0,
        question1: '',
        question2: null,
        question3: null,
        welcomeQuestions: []
      }
    }
  },
  computed: {
    isEdit () {
      return !!this.jobInterviewId
    },
    jobInterviewId () {
      return this.$route.params.jobInterviewId == null ? null : Number(this.$route.params.jobInterviewId)
    },
    requestParam () {
      return {
        name: this.jobInterview.name,
        jobs: this.jobInterview.jobs,
        paperScreening: this.jobInterview.paperScreening,
        paperScreeningRemarks: this.nonInputValueConverter(this.jobInterview.paperScreeningRemarks),
        spiTest: this.jobInterview.spiTest,
        spiTestRemarks: this.nonInputValueConverter(this.jobInterview.spiTestRemarks),
        message: this.jobInterview.message,
        content: this.jobInterview.content,
        interviewers: this.interviewersConverter(this.jobInterview.interviewers),
        requiredTime: this.jobInterview.requiredTime.id === 0 ? null : this.jobInterview.requiredTime,
        requiredTimeRemarks: this.nonInputValueConverter(this.jobInterview.requiredTimeRemarks),
        cloth: this.jobInterview.cloth.id === 0 ? null : this.jobInterview.cloth,
        clothRemarks: this.nonInputValueConverter(this.jobInterview.clothRemarks),
        businessManner: this.jobInterview.businessManner,
        communicationAbility: this.jobInterview.communicationAbility,
        skill: this.jobInterview.skill,
        motivation: this.jobInterview.motivation,
        question1: this.jobInterview.question1,
        question2: this.nonInputValueConverter(this.jobInterview.question2),
        question3: this.nonInputValueConverter(this.jobInterview.question3),
        welcomeQuestions: this.jobInterview.welcomeQuestions
      }
    },
    nonOriginalEntryFormPublishedJobs () {
      return this.publishedJobs.filter(job => job.isOriginalEntryForm === false)
    }
  },
  created () {
    this.fetchJobs()
    this.isEdit ? this.fetchJobInterview() : this.jobInterview.interviewers.push(this.createDefaultInterviewer(1))
  },
  methods: {
    fetchJobs () {
      this.$http.secured.get('/interview/jobs').then(response => {
        this.$set(this, 'publishedJobs', response.data)
      })
    },
    fetchJobInterview () {
      this.$http.secured.get(`/interview/interviews/${this.jobInterviewId}`).then(response => {
        this.setInterview(response.data)
      })
    },
    nonInputValueConverter (target) {
      return target?.length === 0 ? null : target
    },
    interviewersConverter (interviewers) {
      return interviewers.map(interviewer => {
        return {
          no: interviewer.no,
          selectionType: interviewer.selectionType,
          gender: interviewer.gender,
          position: interviewer.position,
          generation: interviewer.generation,
          remarksOrFreeText: this.nonInputValueConverter(interviewer.remarksOrFreeText)
        }
      })
    },
    setInterview (response) {
      // apiのレスポンスオブジェクトがnullになる場合があるので初期値を入れる
      this.$set(this.jobInterview, 'name', response.name)
      this.$set(this.jobInterview, 'jobs', response.jobs)
      this.$set(this.jobInterview, 'paperScreening', response.paperScreening)
      this.$set(this.jobInterview, 'paperScreeningRemarks', response.paperScreeningRemarks)
      this.$set(this.jobInterview, 'spiTest', response.spiTest)
      this.$set(this.jobInterview, 'spiTestRemarks', response.spiTestRemarks)
      this.$set(this.jobInterview, 'message', response.message)
      this.$set(this.jobInterview, 'content', response.content)
      this.setInterviewers(response.interviewers)
      this.$set(this.jobInterview.requiredTime, 'id', _.get(response.requiredTime, 'id') || 0)
      this.$set(this.jobInterview, 'requiredTimeRemarks', response.requiredTimeRemarks)
      this.$set(this.jobInterview.cloth, 'id', _.get(response.cloth, 'id') || 0)
      this.$set(this.jobInterview, 'clothRemarks', response.clothRemarks)
      this.$set(this.jobInterview, 'businessManner', response.businessManner)
      this.$set(this.jobInterview, 'communicationAbility', response.communicationAbility)
      this.$set(this.jobInterview, 'skill', response.skill)
      this.$set(this.jobInterview, 'motivation', response.motivation)
      this.$set(this.jobInterview, 'question1', response.question1)
      this.$set(this.jobInterview, 'question2', response.question2)
      this.$set(this.jobInterview, 'question3', response.question3)
      this.$set(this.jobInterview, 'welcomeQuestions', response.welcomeQuestions)
    },
    createDefaultInterviewer (index) {
      return {
        no: index,
        selectionType: { id: 1, name: '' },
        gender: { id: 0, name: '' },
        position: { id: 0, name: '' },
        generation: { id: 0, name: '' },
        remarksOrFreeText: null
      }
    },
    setInterviewers (interviewers) {
      // apiのレスポンスオブジェクト変換(面接官について)
      interviewers.forEach((element, index) => {
        const interviewer = this.createDefaultInterviewer(index + 1)
        this.$set(interviewer, 'no', element.no)
        this.$set(interviewer.selectionType, 'id', element.selectionType.id)
        this.$set(interviewer.gender, 'id', _.get(element.gender, 'id') || 0)
        this.$set(interviewer.position, 'id', _.get(element.position, 'id') || 0)
        this.$set(interviewer.generation, 'id', _.get(element.generation, 'id') || 0)
        this.$set(interviewer, 'remarksOrFreeText', element.remarksOrFreeText)
        this.jobInterview.interviewers.push(interviewer)
      })
    },
    setSubmittableAndScrollToTop (isSubmittable) {
      this.$set(this, 'isSubmittable', isSubmittable)
      this.$nextTick(() => {
        // 登録・編集確認を表示する時と確認画面から戻る時、上部をフォーカスさせる
        this.$scrollTo('body', 0)
      })
    },
    registerOrUpdate () {
      this.isEdit ? this.update() : this.register()
    },
    update () {
      Indicator.emitShow()
      this.$http.secured.put(`/interview/interviews/${this.jobInterviewId}`, this.requestParam)
        .then(() => {
          this.$toasted.global.success({ message: '面接情報を更新しました。' })
          this.$router.push({ name: 'interviewInformationTop' })
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    register () {
      Indicator.emitShow()
      this.$http.secured.post('/interview/interviews', this.requestParam)
        .then(() => {
          this.$toasted.global.success({ message: '面接情報を登録しました。' })
          this.$router.push({ name: 'interviewInformationTop' })
        }).finally(() => {
          Indicator.emitHide()
        })
    }
  }
}
</script>
